// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html:has(> body > #root > .PdfLayout),
html:has(> body > #root > .PdfLayout) body,
html:has(> body > #root > .PdfLayout) #root {
  width: auto !important;
  height: auto !important;
  overflow: visible;
}
html:has(> body > #root > .PdfLayout) .PdfLayout {
  --pdf-width: 11in;
  --pdf-spacing: 0.39in;
}
html:has(> body > #root > .PdfLayout) .PdfLayout .PdfLayout-Content {
  background-color: #ffffff;
  width: var(--pdf-width);
  min-height: 100vh;
  height: auto;
  margin: 0 auto;
  padding: 0;
  overflow: hidden;
  box-shadow: 0 0 2rem rgba(0, 0, 0, 0.25);
  box-sizing: border-box;
}
html:has(> body > #root > .PdfLayout) .PdfLayout .PdfLayout-Content > .UnknownPdf {
  height: calc(100vh - var(--pdf-spacing));
  display: flex;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
html:has(> body > #root > .PdfLayout) .PdfLayout .PdfLayout-Controls {
  position: fixed;
  top: 1rem;
  right: 1rem;
}
html:has(> body > #root > .PdfLayout) .LoadingBlur {
  background-color: #fff;
}

@media print {
  html,
  body {
    background: transparent;
  }
  html .PdfLayout .PdfLayout-Content,
  body .PdfLayout .PdfLayout-Content {
    width: 100% !important;
    min-height: 100vh;
    height: auto;
    margin: 0;
    padding: 0;
    box-shadow: none;
  }
  html .PdfLayout .PdfLayout-Content > *,
  body .PdfLayout .PdfLayout-Content > * {
    width: 100% !important;
    padding: 0 !important;
  }
  @page {
    html .PdfLayout .PdfLayout-Content,
    body .PdfLayout .PdfLayout-Content {
      size: 100% auto;
      margin: 0 0 0.39in 0;
    }
  }
  html .PdfLayout .PdfLayout-Controls,
  body .PdfLayout .PdfLayout-Controls {
    display: none !important;
  }
  html thead,
  body thead {
    display: table-row-group; /* Overrides the default print display property */
  }
  .print-hide {
    display: none !important;
  }
  .print-break-after {
    page-break-after: always !important;
  }
  .print-break-avoid {
    page-break-inside: avoid !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/features/PdfLayout/styles.scss"],"names":[],"mappings":"AAEE;;;EAGE,sBAAA;EACA,uBAAA;EACA,iBAAA;AADJ;AAGE;EACE,iBAAA;EACA,qBAAA;AADJ;AAEI;EACE,yBAAA;EACA,uBAAA;EACA,iBAAA;EACA,YAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;EACA,wCAAA;EACA,sBAAA;AAAN;AACM;EACE,wCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AACR;AAEI;EACE,eAAA;EACA,SAAA;EACA,WAAA;AAAN;AAGE;EACE,sBAAA;AADJ;;AAIA;EACE;;IAEE,uBAAA;EADF;EAGI;;IACE,sBAAA;IACA,iBAAA;IACA,YAAA;IACA,SAAA;IACA,UAAA;IACA,gBAAA;EAAN;EACM;;IACE,sBAAA;IACA,qBAAA;EAER;EAAM;IAXF;;MAYI,eAAA;MACA,oBAAA;IAIN;EACF;EAFI;;IACE,wBAAA;EAKN;EAFE;;IACE,wBAAA,EAAA,iDAAA;EAKJ;EAFA;IACE,wBAAA;EAIF;EAFA;IACE,mCAAA;EAIF;EAFA;IACE,mCAAA;EAIF;AACF","sourcesContent":["// Only apply these styles when PdfLayout is the main component rendered\nhtml:has(> body > #root > .PdfLayout) {\n  &,\n  body,\n  #root {\n    width: auto !important;\n    height: auto !important;\n    overflow: visible;\n  }\n  .PdfLayout {\n    --pdf-width: 11in;\n    --pdf-spacing: 0.39in;\n    .PdfLayout-Content {\n      background-color: #ffffff;\n      width: var(--pdf-width);\n      min-height: 100vh;\n      height: auto;\n      margin: 0 auto;\n      padding: 0;\n      overflow: hidden;\n      box-shadow: 0 0 2rem rgba(0, 0, 0, 0.25);\n      box-sizing: border-box;\n      > .UnknownPdf {\n        height: calc(100vh - var(--pdf-spacing));\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        display: flex;\n        flex-direction: column;\n        gap: 0.5rem;\n      }\n    }\n    .PdfLayout-Controls {\n      position: fixed;\n      top: 1rem;\n      right: 1rem;\n    }\n  }\n  .LoadingBlur {\n    background-color: #fff;\n  }\n}\n@media print {\n  html,\n  body {\n    background: transparent;\n    .PdfLayout {\n      .PdfLayout-Content {\n        width: 100% !important;\n        min-height: 100vh;\n        height: auto;\n        margin: 0;\n        padding: 0;\n        box-shadow: none;\n        > * {\n          width: 100% !important;\n          padding: 0 !important;\n        }\n        @page {\n          size: 100% auto;\n          margin: 0 0 0.39in 0;\n        }\n      }\n      .PdfLayout-Controls {\n        display: none !important;\n      }\n    }\n    thead {\n      display: table-row-group; /* Overrides the default print display property */\n    }\n  }\n  .print-hide {\n    display: none !important;\n  }\n  .print-break-after {\n    page-break-after: always !important;\n  }\n  .print-break-avoid {\n    page-break-inside: avoid !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
